import React, { Component } from 'react'
import I18n from "i18n-js";
import '../../translations.js';

export default class DailyTable extends Component {
  constructor(props) {
    super(props)
    this.dayList = this.dayList.bind(this)
    this.dayOption = this.dayOption.bind(this)
    this.getValue = this.getValue.bind(this)
    this.dayAssignments = this.dayAssignments.bind(this)
    this.avblUnits = this.avblUnits.bind(this)
    this.avblUnitsByDay = this.avblUnitsByDay.bind(this)
    this.isDisabled = this.isDisabled.bind(this)
    this.isSoldOut = this.isSoldOut.bind(this)
  }

  dateString(date) {
    //correct form -> august 26, 2017

   // return I18n.l(date, short);
    if (I18n.locale === "fr")
      return I18n.strftime(date, "%d %B %Y");
    else
      return I18n.strftime(date, "%B %d, %Y")
    //return this.monthName(date.getMonth()) + " " + ("0" + date.getDate()).slice(-2) + ", " + date.getFullYear()
  }

  dateIncrement(date, days) {
    return new Date(date.getTime() + 1000*60*60*24*days)
  }

  dayList() {
    var tz_date = new Date(this.props.startDate);
    var tz_offset = tz_date.getTimezoneOffset() * 60000;
    var date = new Date(tz_date.getTime() + tz_offset);
    var list = [];
    const daysSinceStart = this.props.showDays + this.props.daysAfter;
    for (var i = 0 - this.props.daysBefore; i < daysSinceStart; i++) {
      list.push({date: this.dateIncrement(date, i),
                 dateName: this.dateString(this.dateIncrement(date, i)),
                 yellow: !(i < 0 || i >= this.props.showDays),
                 dayId: i})
    }
    return list;
  }

  avblUnits() {
    var stalls = this.props.summary.stallsAvailable
    var stalls_daily_type = this.props.summary.stallsDailyType
    var campsites = this.props.summary.campsitesAvailable
    var campsites_daily_type = this.props.summary.campsitesDailyType

    if (stalls_daily_type !== '' && this.props.tabId === 'stalls') {
      return stalls.find(stalls => { return stalls.id == stalls_daily_type }).avbl_daily_units
    } else if (campsites_daily_type !== '' && this.props.tabId === 'campsites') {
      return campsites.find(campsites => { return campsites.id == campsites_daily_type }).avbl_daily_units
    } else {
      return false
    }
  }

  avblUnitsByDay(day) {
    var tab = this.props.tabId
    var units_by_day = this.avblUnits();
    if (tab == 'stalls') {
      var reservation = this.props.summary.stallsDailyReservations.find(reservations => { return reservations.id == day.dayId})
    } else if (tab == 'campsites') {
      var reservation = this.props.summary.campsitesDailyReservations.find(reservations => { return reservations.id == day.dayId})
    }
    if (units_by_day) {
      var reserved = (reservation && reservation.value) || 0;
      return units_by_day.find(units_by_day => { return units_by_day.id == day.dayId}).value + reserved;
    } else {
      return 0
    }
  }

  valueAsOption(value, is_disabled) {
    return <option key={value} value={value}>{`${value} ${this.isSoldOut(is_disabled)}`} </option>
  }

  valueOptions(value) {
    return <option key={value} value={value}>{`${value} `} </option>
  }

  getValue(id) {
    var service = this.props.summary.services.filter((element) => 
      element.id === id.toString() && (element.source === this.props.tabId || element.source === `${this.props.tabId}DailyReservations`))[0];
    if (service) {
      return service.value;
    } else {
      return 0;
    }
  }

  dayAssignments(id) {
    var service = this.props.summary.services.filter((element) => 
      element.id === id.toString() && (element.source === this.props.tabId || element.source === `${this.props.tabId}DailyReservations`))[0];
    if (service) {
      return service.assigned;
    } else {
      return false;
    }
  }

  isDisabled(day) {
    if (this.props.secretary) {
      return false;
    }
    if (this.dayAssignments(day.dayId)) {
      return true
    }
    return this.avblUnitsByDay(day) == 0
  }

  isSoldOut(is_disabled) {
    if (this.props.tabId === 'stalls') {
      return is_disabled && this.props.summary.stallsDailyType != '' ? I18n.t("rts.services.sold_out") : ''
    } else if (this.props.tabId === 'campsites') {
      return is_disabled && this.props.summary.campsitesDailyType != '' ? I18n.t("rts.services.sold_out") : ''
    }
  }

  dayOption(day) {
    const day_value = this.getValue(day.dayId);
    var start_amt = 0;
    const amt_size = 401;
    if (this.dayAssignments(day.dayId)) {
      start_amt = this.dayAssignments(day.dayId).split(',').length;
    }
    if (!this.props.editable) {
      start_amt = day_value;
    }
        
    var avbl = this.props.maxQuantity ? this.props.maxQuantity : (this.avblUnitsByDay(day) + 1);
    var numbers = new Array(amt_size).fill(start_amt, start_amt, avbl);
    var is_disabled = this.isDisabled(day);
    
    return  <tr key={day.dateName} className={day.yellow ? "show-day" : ""}>
              <td>{day.dateName}</td>
              <td>
                {this.props.maxQuantity ?
                  <select className="input-mini input-mini-90" id={`${day.dayId} ${this.props.tabId}`} value={this.getValue(day.dayId)} onChange={this.props.onChange}>
                    { numbers.map((x, index) => this.valueOptions(index)) }
                  </select>
                  :
                  <select className="input-mini input-mini-90" id={`${day.dayId} ${this.props.tabId}DailyReservations`} disabled={is_disabled} value={this.getValue(day.dayId)} onChange={this.props.onChange}>
                    { numbers.map((x, index) => this.valueAsOption(index, is_disabled)) }
                  </select>
                }
              </td>
              <td>
                <label>{this.dayAssignments(day.dayId)}</label>
              </td>
            </tr>
  }

  render() {
    return (
      <table className="table">
        <thead>
          <tr>
            <th>{I18n.t("season_stalls.day")}</th>
            <th>{I18n.t("rts.services.qty")}</th>
            {!this.props.maxQuantity ? 
              <th>{I18n.t("rts.services.assignments")}</th>
              : undefined
            }
          </tr>
        </thead>
        <tbody>
          {this.dayList().map(this.dayOption)}
        </tbody>
      </table>
    )
  }
}
